export const surveyDatasRequestedConstants = {
  CREATE_SURVEY_DATAS_REQUESTED: "CREATE_SURVEY_DATAS_REQUESTED",
  RETRIEVE_SURVEY_DATAS_REQUESTED: "RETRIEVE_SURVEY_DATAS_REQUESTED",
  UPDATE_SURVEY_DATAS_REQUESTED: "UPDATE_SURVEY_DATAS_REQUESTED",
  DELETE_SURVEY_DATAS_REQUESTED: "DELETE_SURVEY_DATAS_REQUESTED",
  DELETE_ALL_SURVEY_DATAS_REQUESTED: "DELETE_ALL_PROJECT",
};
